import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddTeacher from "../../../containers/superadmin/teacher/models/add-teacher";
import SearchBar from "../../../containers/superadmin/teacher/searchbar";
import TeachersTable from "../../../containers/superadmin/teacher/table";
import AddTeacherAdmin from "../../../containers/admin/teacher-admin/models/add-teacher-admin";
import { getAllTeachersRequest } from "../../../modules/superadmin-modules/teachers/Actions";

const SuperadminTeachers = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [addedTeacherAdmin, setAddedTeacherAdmin] = useState({});

  useEffect(() => {
    dispatch(getAllTeachersRequest());
  }, []);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setSelectedData={setSelectedData} />
      <TeachersTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddTeacher
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
      <AddTeacherAdmin
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
        setAddedTeacherAdmin={setAddedTeacherAdmin}
      />
    </Layout>
  );
};

export default SuperadminTeachers;
